<template>
  <div class="outerbox footBox">
    <div class="innercoreversion footBoxcon">
      <div class="boxulli">
        <div class="titlejie">解决方案</div>
        <ul>
          <li>
            <span>茶饮</span>
            <span>4s店</span>
          </li>
          <li>
            <span>餐饮</span>
            <span>百货零售</span>
          </li>
          <li>
            <span>商场</span>
            <span>服装零售</span>
          </li>
          <li>
            <span>酒店</span>
            <span>更多</span>
          </li>
        </ul>
      </div>
      <div class="boxulli">
        <div class="titlejie">解决方案</div>
        <ul>
          <li>
            <span>智能营建</span>
          </li>
          <li>
            <span>智慧巡店</span>
          </li>
          <li>
            <span>智能管理</span>
          </li>
          <li>
            <span>AI场景搭建</span>
          </li>
        </ul>
      </div>
      <div class="boxulli">
        <div class="titlejie">解决方案</div>
        <ul>
          <li>
            <span>服务与支持</span>
          </li>
          <li>
            <span>帮助中心</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="outer">
      <div class="innercoreversion footboutons">
        <div class="spanbox">
          <span>2024 © 亿大师</span>
          <a href="https://beian.miit.gov.cn">粤ICP备2024201122号-1</a>
          <span>宇亿润宸网络科技（深圳）有限公司</span>
        </div>
        <!-- <div class="spanbox">
          <span>中国互联网举报中心</span>
          <span>网络文化许可证-京网文-（2016）2282-264号</span>
          <span>违法和不良信息举报：400-140-2108</span>
          <span>举报邮箱：jubao@yidashi.com</span>
        </div> -->
      </div>
    </div>
    <div class="nowhave">
      <div class="havemarg">
        <vue-qr class="qr-code" :logoSrc="imageUrl" :text="qrCodeUrl" :size="154" />
        <div class="nowprohave">扫一扫立即下载亿大师</div>
      </div>
      <div style="width: 154px">
        <img src="../image/zhuanyan.png" style="width: 100%" alt="" />
        <div class="nowprohave">扫一扫联系服务专员</div>
      </div>
    </div>
  </div>
</template>

<script>
import vueQr from 'vue-qr'
export default {
  name: 'footBox',
  components: {
    vueQr,
  },
  data() {
    return {
      qrCodeUrl: `https://wy.sd-wh.com.cn/h5/training/#/downpage?down=app`,
      imageUrl: require('../image/logo.png'),
    }
  },
}
</script>

<style lang="less" scoped>
ul {
  list-style: none; /* 去掉圆点或数字 */
  padding: 0; /* 去除 ul 默认的内边距 */
  margin: 0; /* 去除 ul 默认的外边距 */
}

li {
  margin: 17px 0 0 0; /* 去除 li 默认的外边距 */
  font-weight: 500;
  font-size: 14px;
  color: #d6d6d6;
}

li > :first-of-type {
  margin-right: 17px;
}
.footBox {
  padding-top: 60px;
  height: 377px;
  background: #171725;
  position: relative;
  //   color: #fff;
  .footBoxcon {
    height: calc(100% - 107px);
    display: flex;
    padding-left: 15px;
    .boxulli {
      margin-right: 154px;
      .titlejie {
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
      }
    }
  }
  .outer {
    width: 100%;
    // background-color: aqua;
    height: 107px;
    border-top: 2px solid rgba(255, 255, 255, 0.2);
    .footboutons {
      height: 100%;
      padding: 24px 0;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .spanbox {
        span {
          padding: 0 15px;
          border-right: 1px solid #ffffff;
        }
        a {
          padding: 0 15px;
          border-right: 1px solid #ffffff;
        }
        a:hover {
          color: #0a5fc0;
        }
        & > :last-child {
          border-right: none;
        }
      }
      & > :first-of-type {
        margin-bottom: 8px;
      }
    }
  }
  .nowhave {
    // width: 100px;
    // height: 100px;
    // background: #d6d6d6;
    position: absolute;
    right: 10%;
    top: 15%;
    display: flex;
    .havemarg {
      margin-right: 10px;
    }
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    line-height: 22px;
    text-align: left;
    .nowprohave {
      width: 160px;
      text-align: center;
    }
  }
}
</style>